const getters = {
  portalUrl: (state) => state.app.portalUrl,
  idCode: (state) => state.app.idCode,
  loading: (state) => state.app.loading,
  mainDOMRect: (state) => state.app.mainDOMRect,
  pressTestUrl: (state) => state.app.pressTestUrl,
  h5previewUrl: (state) => state.app.h5previewUrl,
  projectName: (state) => state.app.projectName,
  windowTitle: (state) => state.app.windowTitle,
  sidebar: (state) => state.app.sidebar,
  tagWel: (state) => state.app.tagWel,
  language: (state) => state.app.language,
  visLanguage: (state) => state.app.visLanguage,
  themeColor: (state) => state.app.themeColor,
  user: (state) => state.login.userInfo,
  memberInfo: (state) => state.login.memberInfo,
  teamMemberInfo: (state) => state.login.teamMemberInfo,
  appInfo: (state) => state.login.appInfo,
  imageBaseUrl: (state) => state.app.imageBaseUrl,
  userface: (state) => state.login.userInfo.headImage,
  menus: (state) => state.login.menus,
  memberMenus: (state) => state.login.memberMenus,
  routes: (state) => state.login.routes,
  roles: (state) => state.login.roles,
  loginActive: (state) => state.login.loginActive,
  loginData: (state) => state.login.loginData,
  access_token: (state) => state.login.access_token,
  refresh_token: (state) => state.login.refresh_token,
  defaultUserPhoto: (state) => state.app.defaultUserPhoto,
  defaultDoctorPhoto: (state) => state.app.defaultDoctorPhoto,
  userCode: (state) => state.params.userCode,
  teamCode: (state) => state.params.teamCode,
  dataType: (state) => state.params.dataType,
  teamCodeBelong: (state) => state.params.teamCodeBelong,
  corpIdCode: (state) => state.corporation.idCode,
  corpMenu: (state) => state.corporation.corpMenu,
  corpUserInfo: (state) => state.corporation.userInfo,
  /**
   * 企业认证状态
   * -1=未认证 默认
   * 0=认证审核中
   * 1=已认证
   * 2=认证未通过
   */
  corpCertificationStatue: (state) => state.corporation.userInfo.corpCertificationStatus,
  // 企业消费统计信息（剩余点数、总消费点数、充值金额）
  corpCostStatistics: (state) => state.corporation.corpCostStatistics
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js